import { Plus, Trash2, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export const ClauseEditor = ({ clauses, onChange }) => {
  const upd = (i, patch) => onChange(clauses.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  return (
    <div className="space-y-3" data-testid="clause-editor">
      {clauses.map((c, i) => (
        <div key={i} data-testid={`clause-item-${i}`} className={cn("rounded-lg border p-3 space-y-2", c.sensitive && "border-primary/40 bg-primary/5")}>
          <div className="flex gap-2 items-center">
            <Input data-testid={`clause-title-${i}`} value={c.title} onChange={(e) => upd(i, { title: e.target.value })} placeholder={`Pasal ${i + 1} — Judul`} className="h-8 text-sm font-medium" />
            <label className="flex items-center gap-1.5 text-xs whitespace-nowrap cursor-pointer"><Checkbox data-testid={`clause-sensitive-${i}`} checked={!!c.sensitive} onCheckedChange={(v) => upd(i, { sensitive: !!v })} /><ShieldAlert className="h-3.5 w-3.5 text-primary" />Sensitif</label>
            <Button type="button" size="icon" variant="ghost" className="h-8 w-8 shrink-0" data-testid={`clause-remove-${i}`} onClick={() => onChange(clauses.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></Button>
          </div>
          <Textarea data-testid={`clause-text-${i}`} rows={3} value={c.text} onChange={(e) => upd(i, { text: e.target.value })} className="text-xs leading-relaxed" />
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" data-testid="clause-add-button" onClick={() => onChange([...clauses, { title: `Pasal ${clauses.length + 1} — `, text: "", sensitive: false, category: "umum" }])}><Plus className="h-4 w-4 mr-1" />Tambah Pasal</Button>
    </div>
  );
};
